import { LogLevel } from '@azure/msal-browser';
export const getMsalConfig = (authority, clientId, cacheLocation, reporter) => {
    const msalConfig = {
        auth: {
            clientId,
            authority,
            redirectUri: '/'
        },
        cache: {
            cacheLocation
        },
        system: {
            iframeHashTimeout: 12000,
            loggerOptions: {
                logLevel: LogLevel.Verbose,
                loggerCallback: (level, message, containsPii) => {
                    if (containsPii) {
                        return;
                    }
                    switch (level) {
                        case LogLevel.Error:
                            reporter.onError(message);
                            return;
                        case LogLevel.Info:
                            reporter.onInfo(message);
                            return;
                        case LogLevel.Verbose:
                            reporter.onVerbose?.(message);
                            return;
                        case LogLevel.Warning:
                            reporter.onWarning?.(message);
                            break;
                    }
                }
            }
        }
    };
    return msalConfig;
};
//# sourceMappingURL=getMsalConfig.js.map